import AssetDetailWrapper from './AssetDetailWrapper';

export default AssetDetailWrapper;
